// src/pages/HackathonDetailPage.tsx
import HackathonDetailPage from "../../components/Hackathons/HackathonDetailPage";

export default function HackathonDetailPageWrapper() {
  return <HackathonDetailPage />;
}
